import { useEffect as n } from "react";
function s(t, e) {
  n(() => {
    if (!e) {
      console.warn("useOnPaste: target element is not found");
      return;
    }
    return e.addEventListener("paste", t), () => {
      e.removeEventListener("paste", t);
    };
  }, [e, t]);
}
export {
  s as useOnPaste
};
